import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ModalContainer from '../../containers/modal';

import FluidContainer from '../layouts/components/fluid-container';

import { showModal, hideReport, showReport } from '../../actions/modal';
import { Body, Heading } from '../typography';
import Button from '../button';
import { GotoSourceButton } from '../buttons-bar';
import { SOURCES } from '../../constants/sources';
import { useWindowSize } from '../../lib/hooks';
import { REPORT_MODAL } from '../../containers/modal/modal-types';
import DefaultLayout from '../layouts/deafult-layout';

const Box = styled.div`
    border-radius: 4px;
    border: 1px solid var(--gray300);
    background-color: var(--gray50);
    padding: 16px;
    max-width: 400px;
`;

const Paragraph = styled.p`
    color: var(--gray800);
    font-size: ${(props) => props.fontSize};
    line-height: 24px;
    width: 397px;
    margin: 8px;
`;

const ChangeUser = styled.button`
    color: var(--blue500);
    text-decoration: none;
    border: none;
    background-color: var(--gray50);

    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

const ButtonContainer = styled.div`
    margin: 0 0 16px 0;
    & > button {
        width: 100%;
    }

    & > a {
        width: 100%;
    }

    ${(props) => props.theme.mediaQueries.tablet} {
        margin: 0 16px 0 0;
    }
`;

const ButtonsContainer = styled(FluidContainer)`
    margin-top: 32px;
`;

const WrongClassroom = ({ assignment, googleUserInfo, onChangeUser, hideReport, showModal, showReport, displayReport }) => {
    const { innerWidth } = useWindowSize();

    const isMobileTablet = innerWidth < 1152;

    const handleClickReport = () => {
        if (isMobileTablet) {
            showModal(REPORT_MODAL);
            showReport();
            return;
        }
        if (displayReport) {
            hideReport();
            return;
        }
        showReport();
    };

    return (
        <DefaultLayout exercises={[]} status={{}} profile={{ status: {} }}>
            <ModalContainer />

            <FluidContainer flexDirection="column" maxWidth={['100%', '100%', '100%']} paddingTop={[178, 168, 140]}>
                <Heading level={2} weight="light">
                    {'Questa prova è riservata'}
                </Heading>
                <br />
                <Body>{`Questa prova è stata assegnata alla classe ${assignment.className}, ed è riservata.`}</Body>
                <Body>{`Fai parte della ${assignment.className}? Controlla se l'account che stai usando è quello giusto.`}</Body>
                <br />
                <Box>
                    <Paragraph fontSize="16px">
                        {"Stai usando l'account "}
                        <b>{googleUserInfo?.name}</b>
                        {' ('}
                        {googleUserInfo?.email}
                        {').'}
                    </Paragraph>
                    <Paragraph fontSize="12px">
                        {"Non è l'account giusto?"}{' '}
                        <ChangeUser
                            onClick={() => {
                                onChangeUser();
                            }}
                        >
                            {'Usa un altro account'}
                        </ChangeUser>
                    </Paragraph>
                </Box>
                <br />
                <Body>{`Hai bisogno di aiuto? Contattaci`}</Body>
                <br />
                <ButtonsContainer flexDirection={['column', 'row', 'row']}>
                    <ButtonContainer>
                        <GotoSourceButton source={SOURCES.GOOGLE_CLASSROOM} type="primary" />
                    </ButtonContainer>
                    <ButtonContainer>
                        <Button type="tertiary" onClick={() => handleClickReport()} size="small">
                            {'Contattaci'}
                        </Button>
                    </ButtonContainer>
                </ButtonsContainer>
            </FluidContainer>
        </DefaultLayout>
    );
};

WrongClassroom.propTypes = {
    assignment: PropTypes.object,
    googleUserInfo: PropTypes.object,
    hideReport: PropTypes.func,
    showModal: PropTypes.func,
    showReport: PropTypes.func,
    onChangeUser: PropTypes.func,
    displayReport: PropTypes.bool,
};

function mapStateToProps(state) {
    return {
        assignment: state.assignment,
        googleUserInfo: state.googleAuth.userInfo,
        displayReport: state.modal.showReport,
    };
}

const actionCreators = {
    hideReport,
    showModal,
    showReport,
};

export default connect(mapStateToProps, actionCreators)(WrongClassroom);
